export default "__VITE_ASSET__7$7lOykr__"